import React from 'react';

import { OfferCardConditions } from '@modules/PDP/components/OfferCardConditions/OfferCardConditions';
import { OfferCardPricings } from '@modules/PDP/components/OfferCardPricings/OfferCardPricings';

import styles from './PaymentPlanRentingBox.module.scss';
import { OptionSelector } from '../../../../../../base-components/OptionSelector/OptionSelector';
import { FinanceDurationPDP } from '../FinanceDurationPDP/FinanceDurationPDP';

export const PaymentPlanRentingBox = ({
  readMoreText,
  conditionText,
  conditionsLink,
  currencyFormatter,
  groupedPricings,
  selectedMainProductPricing,
  setSelectedMainProductPricing,
  durationText,
  durationsLink,
}) => {
  return (
    <div className={styles.offerCards}>
      <OfferCardConditions
        readMoreText={readMoreText}
        conditionText={conditionText}
        conditionsLink={conditionsLink}
        currencyFormatter={currencyFormatter}
        groupedPricings={groupedPricings}
        selectedMainProductPricing={selectedMainProductPricing}
        setSelectedMainProductPricing={setSelectedMainProductPricing}
      />

      <FinanceDurationPDP
        title={durationText}
        handlePricingChange={setSelectedMainProductPricing}
        selectedFinancePricing={selectedMainProductPricing}
      />
    </div>
  );
};
